import React, { PropTypes } from 'react';
import Paper from 'material-ui/Paper';
import AppBar from 'material-ui/AppBar';
import emptyFunction from 'fbjs/lib/emptyFunction';
import IconButton from 'material-ui/IconButton';
import IconClose from '../Icons/IconClose';

export class FullPageDialog extends React.Component {
  static propsType = {
    label: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    children: PropTypes.node.isRequired,
    style: PropTypes.object
  };

  static defaultProps = {
    onClose: emptyFunction
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  componentWillMount() {
    this.style = this.getStyle();
  }

  getStyle() {
    const { navBar } = this.context.muiTheme;

    return {
      root: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: navBar.openedWidth,
        right: 0,
        zIndex: 1000,
        backgroundColor: 'white'
      },
      content: {
        position: 'absolute',
        top: 64,
        bottom: 0,
        left: 0,
        right: 0,
        padding: 30,
        overflow: 'scroll',
        ...this.props.style
      },
      appBarElementLeft: {
        display: 'none'
      }
    };
  }

  render() {
    const { label, children, onClose } = this.props;
    let {
      palette: { labelColor }
    } = this.context.muiTheme;
    return (
      <Paper zDepth={5} style={this.style.root}>
        <AppBar
          title={label}
          iconStyleLeft={this.style.appBarElementLeft}
          iconElementLeft={<IconButton />}
          iconElementRight={
            <IconButton onClick={onClose}>
              <IconClose />
            </IconButton>
          }
          titleStyle={{ color: labelColor }}
        />
        <div style={this.style.content}>{children}</div>
      </Paper>
    );
  }
}

export default FullPageDialog;



// WEBPACK FOOTER //
// ./src/components/common/FullPageDialog.js